import type { Platform } from '../types/platforms'

export type PlatformTableItem = Platform & {
	environmentLabel?: string
}

const environmentMap = [
	{ label: 'Development', value: 'dev' },
	{ label: 'Staging', value: 'staging' },
	{ label: 'Production', value: 'prod' }
]

const getCreationTime = (platform: Platform) => {
	const creationTime = Date.parse(platform?.creationTime || '')

	return Number.isNaN(creationTime) ? 0 : creationTime
}

export const getSortedPlatformTableItems = (
	platforms: Platform[] = []
): PlatformTableItem[] =>
	[...platforms]
		.map((platform) => ({
			...platform,
			environmentLabel: environmentMap.find(
				(environment) => environment.value === platform.environment
			)?.label
		}))
		.sort((a, b) => getCreationTime(b) - getCreationTime(a))
